// extracted by mini-css-extract-plugin
export default {"boardContainer":"Board_boardContainer__umGVQ","sectionTitle":"Board_sectionTitle__TsNH9","chartTitle":"Board_chartTitle__R6t4y"};